import PropTypes from "prop-types";
import { useEffect } from "react";
import GalleryMediaItem from "./GalleryMediaItem";
import Modal from '../../../components/Modal';
import { useModal } from '../../../hooks/useModal';
import { getMediaDescription } from "../../media/utils/mediaUtils.js";
import { galleryShell } from "../../../styles/galleryShell";

function GalleryModal({ media, location, onClose, onDelete }) {
    const { isOpen, openModal, closeModal } = useModal();

    useEffect(() => {
        if (media && location) {
            openModal();
        }
    }, [media, location, openModal]);

    const handleClose = () => {
        closeModal();
        onClose();
    };

    const handleDelete = async (mediaId) => {
        if (onDelete) {
            const success = await onDelete(mediaId);
            if (success) {
                handleClose();
            }
        }
    };

    if (!media || !location) return null;

    const creator = location.user?.trim() || "";
    const description = getMediaDescription(media)?.trim() || "";

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            title={location.title}
            size="large"
            showCloseButton={true}
            closeOnBackdropClick={true}
            closeOnEscape={true}
            className={galleryShell.modalPanel}
            contentClassName="!flex !min-h-0 !flex-1 !flex-col !overflow-hidden p-0"
            actions={[]}
        >
            <div className={galleryShell.modalBody}>
                <div className={galleryShell.modalStage}>
                    <GalleryMediaItem item={media} onDelete={handleDelete} />
                </div>

                <div className={galleryShell.modalMeta}>
                    <div className={galleryShell.modalMetaRow}>
                        <span className={galleryShell.modalMetaLabel}>作成者</span>
                        <span
                            className={
                                creator
                                    ? galleryShell.modalMetaValue
                                    : galleryShell.modalMetaValueMuted
                            }
                        >
                            {creator || "—"}
                        </span>
                    </div>
                    <div className={galleryShell.modalMetaRow}>
                        <span className={galleryShell.modalMetaLabel}>説明</span>
                        <span
                            className={`${galleryShell.modalMetaDesc} ${description
                                    ? galleryShell.modalMetaValue
                                    : galleryShell.modalMetaValueMuted
                                }`}
                        >
                            {description || "—"}
                        </span>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

GalleryModal.propTypes = {
    media: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        url: PropTypes.string.isRequired,
        media_type: PropTypes.oneOf(["image", "video", "audio"]).isRequired,
        filename: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string
    }).isRequired,
    location: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
        user: PropTypes.string,
        latitude: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired
    }).isRequired,
    onClose: PropTypes.func.isRequired,
    onDelete: PropTypes.func
};

export default GalleryModal;
